import type { Key } from "@zapier/design-system";
import type { Connection } from "@zapier/client";

/** Whether `id` is the account owner, whom the backend never lets you unshare. */
export const isAccountOwnerId = (
  id: Key | null | undefined,
  accountOwnerId: number | null | undefined,
) => accountOwnerId != null && String(id) === String(accountOwnerId);

/** Whether the connection is shared with anyone the share modal lets you remove. */
export function hasRemovableShare(
  connection: Connection,
  accountOwnerId: number | null | undefined,
) {
  return (
    !!connection.sharedWithAll ||
    !!connection.groups?.length ||
    !!connection.members?.some(
      (member) => !isAccountOwnerId(member.id, accountOwnerId),
    )
  );
}
